const printVoucher = (payments) => {
  const voucherWindow = window.open("", "_blank");

  const totalAmount = payments.reduce(
    (sum, p) => sum + Number(p.amount || 0),
    0,
  );

  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Comprobante de Pago</title>
      <style>
        /* General styles for screen display */
        body {
          font-family: monospace;
          font-size: 10px;
          padding: 10px;
          line-height: 1.2; /* Adjust line height for better spacing */
          -webkit-print-color-adjust: exact; /* Ensure background colors are printed */
          color-adjust: exact;
        }

        h2 {
          text-align: center;
          font-size: 12px;
          margin-bottom: 10px; /* Add some space below the title */
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed; /* Ensures columns maintain their width */
        }

        th, td {
          padding: 2px 1mm; /* Added horizontal padding for better spacing */
          word-wrap: break-word;
          font-size: 10px;
          text-align: left; /* Align text to the left by default */
        }

        th {
          font-weight: bold;
          border-bottom: 1px dashed #000;
          text-align: left; /* Ensure headers are left-aligned */
        }

        /* Specific column alignment for better readability */
        td:nth-child(3), th:nth-child(3) { /* Valor column */
          text-align: right;
        }

        .total {
          margin-top: 8px;
          text-align: right;
          font-weight: bold;
          font-size: 10px; /* Ensure total font size is consistent */
        }

        /* Print styles */
        @media print {
          @page {
            margin: 3mm; /* Further reduced overall margin for printing */
          }

          body {
            font-family: monospace;
            padding: 0;
            margin: 0;
            line-height: 1; /* Even tighter line height for print */
          }

          h2 {
            font-size: 12px; /* Smaller title for print */
            margin-bottom: 3px;
          }

          th, td {
            padding: 0.5mm 0.2mm; /* Minimal padding for print */
          }

          .total {
            margin-top: 3px;
            font-size: 9px; /* Consistent total font size for print */
          }

          /* Specific adjustments for 58mm paper */
          @page:size(58mm) {
            body {
              width: 58mm;
              font-size: 6.5px; /* Even smaller font for 58mm */
            }

            th, td {
              font-size: 6px; /* Even smaller font for table content */
            }

            h2 {
              font-size: 8.5px;
            }

            .total {
              font-size: 6.5px;
            }

            /* Adjust column widths for 58mm to optimize space */
            table th:nth-child(1), table td:nth-child(1) { /* Medio */
              width: 30%;
            }
            table th:nth-child(2), table td:nth-child(2) { /* Fecha */
              width: 20%;
            }
            table th:nth-child(3), table td:nth-child(3) { /* Valor */
              width: 25%; /* Slightly more space for value */
            }
            table th:nth-child(4), table td:nth-child(4) { /* Desc */
              width: 25%; /* Slightly less space for description */
            }
          }

          /* Specific adjustments for 80mm paper */
          @page:size(80mm) {
            body {
              width: 80mm;
              font-size: 7.5px; /* Slightly larger font for 80mm */
            }

            th, td {
              font-size: 7px;
            }

            h2 {
              font-size: 9.5px;
            }

            .total {
              font-size: 7.5px;
            }

            /* Adjust column widths for 80mm, similar to 58mm for consistency */
            table th:nth-child(1), table td:nth-child(1) { /* Medio */
              width: 30%;
            }
            table th:nth-child(2), table td:nth-child(2) { /* Fecha */
              width: 20%;
            }
            table th:nth-child(3), table td:nth-child(3) { /* Valor */
              width: 25%;
            }
            table th:nth-child(4), table td:nth-child(4) { /* Desc */
              width: 25%;
            }
          }

          /* Design for letter size or wider */
          @media print and (min-width: 100mm) {
            body {
              width: auto;
              max-width: 80%;
              margin: auto;
              font-size: 11px;
            }

            th, td {
              font-size: 10px;
            }

            h2 {
              font-size: 12px;
            }

            .total {
              font-size: 11px;
            }
          }
        }
      </style>
    </head>
    <body>
      <h2>Comprobante de Pago</h2>
      <table>
        <thead>
          <tr>
            <th>Medio</th>
            <th>Fecha</th>
            <th>Valor</th>
            <th>Desc</th>
          </tr>
        </thead>
        <tbody>
          ${payments
            .map((p) => {
              // Use optional chaining and nullish coalescing for robust data access
              const medio = p["statement."]?.name?.split(" - ").pop() || "";
              const fecha = p.date || "";
              const valor = Number(p.amount || 0).toLocaleString("es-CO", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
              const descripcion = p["sale."]?.rec_name || "";
              return `
                <tr>
                  <td>${medio}</td>
                  <td>${fecha}</td>
                  <td>$${valor}</td>
                  <td>${descripcion}</td>
                </tr>
              `;
            })
            .join("")}
        </tbody>
      </table>
      <p class="total">Total: $${totalAmount.toLocaleString("es-CO", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</p>
      <script>
        window.onload = function () {
          window.print();
          // Close the new window after printing (optional, but common for print)
          setTimeout(() => window.close(), 1000);
        }
      </script>
    </body>
    </html>
  `;

  voucherWindow.document.write(htmlContent);
  voucherWindow.document.close();
};

export default printVoucher;
